import {Component, cloneElement} from 'react';
import PropTypes from 'prop-types';
import {Popover} from '@emoney/kyber';

export default class WithPopover extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isExpanded: false
		};

		this.triggerPopover = this.triggerPopover.bind(this);
		this.hidePopover = this.hidePopover.bind(this);
		this.saveTriggerRef = this.saveTriggerRef.bind(this);
		this.getTrigger = this.getTrigger.bind(this);
	}

	saveTriggerRef(trigger) {
		this.trigger = trigger;
	}

	getTrigger() {
		return this.trigger;
	}

	showPopover() {
		this.setState({
			isExpanded: true
		});
	}

	hidePopover() {
		this.setState({
			isExpanded: false
		});

		if (this.props.onHide) {
			this.props.onHide();
		}
	}

	triggerPopover() {
		if (this.state.isExpanded) {
			this.hidePopover();
		} else {
			this.showPopover();
		}
	}

	render() {
		const {containerClassName, titleId, trigger, popoverProps, children} = this.props;
		const {isExpanded} = this.state;
		const childrenWithHideCallback = cloneElement(children, {
			onHide: this.hidePopover
		});
		const triggerWithProps = cloneElement(trigger, {
			ref: this.saveTriggerRef,
			onClick: this.triggerPopover
		});

		return (
			<div className={containerClassName}>
				{triggerWithProps}
				<Popover
					show={isExpanded}
					labeledby={titleId}
					onRequestClose={this.hidePopover}
					positionTo={this.getTrigger}
					autohide={false}
					{...popoverProps}
				>
					{childrenWithHideCallback}
				</Popover>
			</div>
		);
	}
}

WithPopover.propTypes = {
	containerClassName: PropTypes.string,
	titleId: PropTypes.string.isRequired,
	popoverProps: PropTypes.object,
	trigger: PropTypes.node.isRequired,
	children: PropTypes.node.isRequired,
	onHide: PropTypes.func
};